import React from 'react';
import PropTypes from "prop-types";

import {Button, IconButton, Tooltip} from "@mui/material";
import {CloudUploadOutlined, CloudDownloadOutlined} from "@mui/icons-material";
import {useTranslation} from "react-i18next";

const FieldFileInput = ({
    field,
    label,
    defaultValue,
    onChange,
    row = 0,
    uploadDisabled = false,
    allowedFileExtensions = [],
    required = false,
    readOnly = false,
    icon = <CloudUploadOutlined />,
    iconOnly = false,
}) => {
    const { t } = useTranslation();
    const id = `file-input-${row}-${field}`;
    const renderAsIcon = icon && iconOnly;
    const extensionsString = allowedFileExtensions.join(',');

    const handleChange = (e) => {
        const file = e.target.files?.[0] ?? null;
        if (file && onChange) {
            onChange(file, field);
        }
    };

    if (readOnly) return null;

    const fileName =
        typeof defaultValue === 'string'
            ? defaultValue
            : defaultValue instanceof File
                ? defaultValue.name
                : '';

    return (
        <label htmlFor={id} style={{ display: 'flex', alignItems: 'center' }}>
            {renderAsIcon ? (
                <Tooltip title={fileName ? `Descargar ${label}` : `Subir ${label}`}>
                    {typeof defaultValue === 'string' && fileName.length > 0 ? (
                        <a href={process.env.REACT_APP_API_FILE_URI + fileName} download style={{ textDecoration: "none" }}>
                            <CloudDownloadOutlined color="success" style={{ width:32, marginTop:8 }}>
                                {icon}
                            </CloudDownloadOutlined>
                        </a>
                    ) : (
                        <IconButton component="span" color={fileName.length > 0 ? "success" : "info"} disabled={uploadDisabled}>
                            {icon}
                            <input id={id}
                                type="file"
                                name={field}
                                disabled={uploadDisabled}
                                accept={extensionsString}
                                style={{ display: 'none' }}
                                onChange={handleChange}
                                required={required}
                            />
                        </IconButton>
                    )}
                </Tooltip>
            ) : (
                <Button
                    variant="outlined"
                    color="info"
                    component="span"
                    startIcon={icon}
                    disabled={uploadDisabled}
                >
                    {t(label ?? field)}
                    <input id={id}
                        disabled={uploadDisabled}
                        type="file"
                        name={field}
                        accept={extensionsString}
                        style={{ display: 'none' }}
                        onChange={handleChange}
                        required={required}
                    />
                </Button>
            )}
        </label>
    );
};

FieldFileInput.propTypes = {
    field: PropTypes.string.isRequired,
    label: PropTypes.string,
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(File)]),
    onChange: PropTypes.func.isRequired,
    row: PropTypes.number,
    uploadDisabled: PropTypes.bool,
    allowedFileExtensions: PropTypes.arrayOf(PropTypes.oneOf(['.pdf', '.xml'])),
    required: PropTypes.bool,
    readOnly: PropTypes.bool,
    icon: PropTypes.element,
    iconOnly: PropTypes.bool,
};

export default FieldFileInput;
